import { Component, OnInit } from '@angular/core';
import {PRIVILEDGES} from '../modules/service/roles.mockup';
import {Router} from '@angular/router';
import {DashboardService} from '../modules/service/dashboard.service';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-rpa-test',
  templateUrl: './rpa-test.component.html',
  styleUrls: ['./rpa-test.component.scss']
})
export class RpaTestComponent implements OnInit {


usr={
  email:'',
  location:'',

}
  constructor( private router:Router, private service: DashboardService) { }

  ngOnInit() {
     
  }



login(){
   // Swal.showLoading();


  var test = JSON.stringify(this.usr)

    this.service.rpa(test).subscribe(data=>{

      //console.log(data)
      // Swal.close();
      // (Swal as any).fire({
      //  icon: 'success',
      //   text: 'Welcome to smartCover Dashboard',
      //   timer: 1000,
      //  showConfirmButton: false
      // });
    //  swal.close();
      if(data['responseCode'] === '000'){
         (Swal as any).fire({
       icon: 'success',
         text: 'Submitted Successfully',
        // timer: 1000,
       showConfirmButton: true
      });
        // localStorage.setItem('isLoggedInStatus', JSON.stringify(data['profile'][0]));
        // localStorage.setItem('userdata',JSON.stringify(data['profile'][0]));
          //console.log(data);
      //   if(data['profile'][0]['role']==="manager"){
      //     this.router.navigate(['dashboard']);
  
      //  }else{
      //   this.router.navigate(['dashboard']);

      //  }
        
        
       
     } 
     else if(data['responseCode']==='W1012'){
              //  alert("Invalid Credential");
             Swal.showLoading();
            (Swal as any).fire({ 
            title: 'Warning!',
            text: 'Please fill form',
            icon: 'warning',
          });


       }else if(data['responseCode']==='W1013'){
         alert("Wrong UserEmail Or Password ");
         Swal.showLoading();
         (Swal as any).fire({
        title: 'Oops...',
        text: 'Check your Credentials and Type Again!',
        icon: 'error'
         });

       }



    });
    
  }
}


